module.exports = __webpack_public_path__ + "img/ic_mpe_bed_sm1_press.9d222b1f.png";